import { assign } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  ...mapGetters('app/patient/agendas', [
    'agendas',
    'loading'
  ]),
  me () {
    return [assign({}, {
      id: null,
      name: this.user.name,
      label: this.user.name,
      type: 'user'
    })]
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/computed.js